import { handleActions } from 'redux-actions'
import * as type from './type'
import { changeTableSettings, createInitialTableState } from '../../form/state/table-state-helper'
import { createInitialTableState as createInitialTableStateReducer, createReducerFunction, DESC } from '../../table/state/reducer'

export const initialState = {
    taskListWithAttachment: [],
    allOpenTaskList: [],
    allOpenTask: {},
    fetching: false,
    error: null,
    ...createInitialTableState({
        rowsPerPage: 20,
        sortColumnName: 'created',
        sortOrder: -1,
    }),

    ...createInitialTableStateReducer(type.TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT, 'process_task_all', {
        'process_task.created': DESC,
    }),
}


export default handleActions({
    ...createReducerFunction(type.TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT),

    [type.CHANGE_TABLE_SETTING]: changeTableSettings(),

    [type.FIND_TASK_LIST_WITH_ATTACHMENT_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.FIND_TASK_LIST_WITH_ATTACHMENT_SUCCESS]: (state, action) => {
        const { taskListWithAttachment } = action.payload
        return {
            ...state,
            taskListWithAttachment,
            fetching: false,
        }
    },
    [type.FIND_TASK_LIST_WITH_ATTACHMENT_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/worklist-attachment/state/reducer.js